import axios from "axios";
import { $authHost } from "./indexApi";
import { UPDATE_CALENDAR, UPDATE_CLIENT_INFO, UPDATE_INVOICE_NUMBER, UPDATE_TOTAL_BILLED, UPDATE_EMAIL_TEXT, UPDTATE_COUNSELLOR_PHONE, UPDATE_BAD_FIT_ITEM } from "./mutations";
import { GET_ADMIN_COUNSELLORS, GET_INVOICES_NUMBERS, GET_INVOICE_NUMBER, GET_TOTAL_BILLED, GET_EMAIL_TEXT, GET_BAD_FIT } from "./query";

export const exportToPdf = async (dataForExport) => await $authHost.post(`${process.env.REACT_APP_BASE_URL}/pdf/`, dataForExport, {
    responseType: 'blob'
})

export const exportToZip = async (dataForExport) => await $authHost.post(`${process.env.REACT_APP_BASE_URL}/pdf/zip`, dataForExport, {
    responseType: 'blob'
})

export const getInvoiceNumber = async () => {
    const {data: {data: {invoiceNumber}}} = await $authHost.post(`${process.env.REACT_APP_BASE_URL}/graphql`, {
        query: GET_INVOICE_NUMBER,
    })
    
    return invoiceNumber
}

export const getTotalBilled = async (acuityID) => {
    const {data: {data: {appointments: [clientAppointment]}}} = await $authHost.post(`${process.env.REACT_APP_BASE_URL}/graphql`, {
        query: GET_TOTAL_BILLED,
        variables: {params: {acuityID}}
    })

    return clientAppointment.totalBilled
}
    

export const updateInvoiceNumber = async (number) => {
    const {data: {data: {invoiceNumber: {invoiceNumber}}}} = await $authHost.post(`${process.env.REACT_APP_BASE_URL}/graphql`, {
        query: UPDATE_INVOICE_NUMBER,
        variables: {invoiceNumber: number}
    })
    
    return invoiceNumber
}

export const updateTotalBilled = async (number, firstName, lastName) => {
    const variables = {
        mutateParams: {
            firstName,
            lastName,
            totalBilled: number
        }
    }

    const {data: {data: {client: {totalBilled}}}} = await $authHost.post(`${process.env.REACT_APP_BASE_URL}/graphql`, {
        query: UPDATE_TOTAL_BILLED,
        variables
    })
    
    return totalBilled
}

export const getInvoicesNumbers = async (operationId) => {
    const {data: {data: {extractedInvoiceNumbers}}} = await $authHost.post(`${process.env.REACT_APP_BASE_URL}/graphql`, {
        query: GET_INVOICES_NUMBERS,
        variables: {operationId}
    })
    
    return extractedInvoiceNumbers
}

export const updateCounsellorInfo = async (mutateParams = {}, requestParams = {}) => {
    const {data: { data: {counsellor: [counsellorItem]}}} = await $authHost.post(`${process.env.REACT_APP_BASE_URL}/graphql`, {
        query: UPDATE_CALENDAR,
        variables: {
            mutateParams,
            requestParams
        }
    })
    
    return counsellorItem
}

export const getAdminCounsellors = async (counsellorID) => {
    const {data: {data: {counsellors}}} = await $authHost.post(`${process.env.REACT_APP_BASE_URL}/graphql`, {
        query: GET_ADMIN_COUNSELLORS,
        variables: {
            params: {
                counsellorID
            }
        }
    })
    
    return counsellors
}

export const updateClientInfo = async (mutateParams) => {
    const {data: {data: {client}}} = await $authHost.post(`${process.env.REACT_APP_BASE_URL}/graphql`, {
        query: UPDATE_CLIENT_INFO,
        variables: {mutateParams}
    })
    
    return client
}

export const updateCounsellorPassword = async (newPassword, oldPassword) => {
    const formData = new FormData()
    formData.append("old_password", oldPassword)
    formData.append("new_password", newPassword)
    await $authHost.post('/auth/password/set', formData)
}

export const signIn = async (username, password) => {
    const formData = new FormData()
    formData.append("username", username)
    formData.append("password", password)
    
    const {data: {access_token: token}} = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/login`, formData)

    return token
}

export const verifyToken = async () => {
    const {data} = await $authHost.get('/auth/authenticate')

    return data
}

export const emailPassword = async (email) => {
    await $authHost.post(`/auth/password/generate?email=${email}`)
}

export const getEmailText  = async () => {
    const {data: { data: {emailText: {text}}}} = await $authHost.post(`${process.env.REACT_APP_BASE_URL}/graphql`, {
        query: GET_EMAIL_TEXT
    })

    return text
}

export const updateEmaiText  = async (emailText) => {
    const {data: { data: {emailText: {text}}}} = await $authHost.post(`${process.env.REACT_APP_BASE_URL}/graphql`, {
        query: UPDATE_EMAIL_TEXT,
        variables: {
            text: emailText
        }
    })

    return text
}

export const sendEmailInvoice = async ({email, text, title, file, fileName}) => {
    const formData = new FormData()
    formData.append("email", email)
    formData.append("text", text)
    formData.append("title", title)
    formData.append("file", file)
    formData.append("filename", fileName)

    await $authHost.post(`${process.env.REACT_APP_BASE_URL}/send_email/`, formData)
}

export const updateCounsellorPhone = async (phone) => {
    await $authHost.post(`${process.env.REACT_APP_BASE_URL}/graphql`, {
        query: UPDTATE_COUNSELLOR_PHONE,
        variables: {
            mutateParams: {
                phone
            }
        }
    })
}

export const getBadFitItems = async () => {
    const {data: { data: {badFit}}} = await $authHost.post(`${process.env.REACT_APP_BASE_URL}/graphql`, {
        query: GET_BAD_FIT
    })

    return badFit
}

export const updateBadFitItem = async (badFitId, params) => {
    const {data: { data: {badFit}}} = await $authHost.post(`${process.env.REACT_APP_BASE_URL}/graphql`, {
        query: UPDATE_BAD_FIT_ITEM,
        variables: {
            badFitId,
            params: {
                goodForMonth: null,
                ...params
            }
        }
    })

    return badFit
}